module.exports = __webpack_public_path__ + "static/media/sombra-interna-miolo-direito.c129d621.svg";